// Material UI import
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

// Font Awesome import
import { faArrowLeft } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Component import
import RatesDetails from '../../RatesDetails.js';
import { RateCard } from '../../RateCard.js';

function SidePaneOpportunityBuyingRatesDrawer(props) {
    const { onClose, rates, organization, exchangeRates, emphasize, setMinimizedSearch, prefix, transportationMethod, products } = props;
    const theme = useTheme();
    return (
        <Box sx={{ width: '100%', paddingBottom: '24px', overflowY: 'auto' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', background: 'transparent', padding: '6px 24px', mb: 3, borderBottom: '1px solid rgba(59, 130, 246, 0.3)', boxShadow: 'none' }}>
                <Typography variant='body1' sx={{ fontSize: '12px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em', color: '#334155' }}>
                    Cost Center
                </Typography>
                <IconButton color='inherit' onClick={onClose} sx={{ fontSize: '13px', gap: '6px', borderRadius: '6px' }}>
                    <FontAwesomeIcon icon={faArrowLeft} /> Back
                </IconButton>
            </Box>
            <Box sx={{ padding: '0px 24px' }}>
                {prefix}
                {(rates || []).map(r => (
                    <Box key={r.id} sx={{ paddingBottom: '24px' }}>
                        {(r.source || r._rfqSource) && (
                            <Box sx={{ marginBottom: '30px' }}>
                                <RateCard
                                    organization={organization}
                                    rate={r}
                                    exchangeRates={exchangeRates}
                                    transitDatesIndex={0}
                                    onStartDragging={() => setMinimizedSearch(true)}
                                    onEndDragging={() => setMinimizedSearch(false)}
                                    standaloneWithDragging={true}
                                    opportunityProducts={products}
                                />
                            </Box>
                        )}
                        <RatesDetails
                            organization={organization}
                            rates={[r]}
                            emphasize={emphasize}
                            onStartDragging={() => setMinimizedSearch(true)}
                            onEndDragging={() => setMinimizedSearch(false)}
                            transportationMethod={transportationMethod}
                            opportunityProducts={products}
                        />
                    </Box>
                ))}
            </Box>
        </Box>
    )
}

export default SidePaneOpportunityBuyingRatesDrawer;
